// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invoices-table-header{border-bottom:2px solid #000}.invoices-table-row{border-bottom:1px solid #bdbdbd}.download-link{width:3rem;height:3rem;text-decoration:none;border-radius:50%}.download-link:hover{background:rgba(0,0,0,.04)}", ""]);
// Exports
module.exports = exports;
